import Contact, { IContact, IContactApiModel } from './Contact.model';

export interface IStudioContact {
  id: number;
  contactId: string;
  contact: IContact;
}

export interface IStudioContactApiModel {
  id: number;
  contactId: string;
  contact: IContactApiModel;
}

export default class StudioContact implements IStudioContact {
  public readonly id: number;

  public readonly contactId: string;

  public readonly contact: IContact;

  constructor(id: number, contactId: string, contact: IContact) {
    this.id = id;
    this.contactId = contactId;
    this.contact = contact;
  }

  static fromApiModel(apiModel: IStudioContactApiModel) {
    const { id, contactId } = apiModel;

    const contact = Contact.fromApiModel(apiModel.contact);

    return new StudioContact(id, contactId, contact);
  }

  static arrayFromApiModel(arrayApiModel: IStudioContactApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, contactId } = apiModel;

      const contact = Contact.fromApiModel(apiModel.contact);

      return new StudioContact(id, contactId, contact);
    });

    return array;
  }
}
